const shopifyOrderId = new URL(window.location).searchParams.get("id");
// `URL.searchParams.get` returns `string|null`...

export default function useShopifyOrderId() {
  return shopifyOrderId;
}
